
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { EditDataSetSidebar } from "./EditDataSetSidebar";
import DataItems from "./DataItems";
import CoreDetails from "./CoreDetails";
import IngestWorkflow from "./IngestWorkflow";
import { BackLink, Button, CancelButton, PageTitle, PageHeader } from "../../../components/StyledElements";
import { getDataSet } from "../../../services/data"
import Loading from "../../../components/Loading";

import { useDataSets } from "../../../contexts/DataSetsContext";

export const EditDataSet = () => {
  const activeUser = useSelector((state) => state.users.activeUser);
  const navigate = useNavigate();
  const { data_set_id } = useParams();
  const [selectedTab, setSelectedTab] = useState(window.location.hash ? window.location.hash.substr(1) : "details");

  const { selectedDataSet, setUpdatedDataSet, updatedDataSet, canSaveDataSet, saveUpdatedEvent } = useDataSets();
  const [savingDataSet, setSavingDataSet] = useState(false);

  useEffect(() => {
    // Fetch live event details using data_set_id
    console.log("!!! FETCHING EVENT ID: ", data_set_id);
    const fetchDataSet = async () => {
      const dataSet = await getDataSet(data_set_id, true);
      console.log("!!! data SET: ", dataSet);
    };
    if (data_set_id) {
      fetchDataSet();
    } else {
      setUpdatedDataSet({
        public_id: "",
        title: "",
        event_type: "live",
        price: 0.00,
        moderator_agent_instructions: "",
        auto_moderation: true,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data_set_id]);

  const saveDataSet = async () => {
    if (!canSaveDataSet() || savingDataSet) {
      return;
    }
    setSavingDataSet(true);
    const public_id = await saveUpdatedEvent();
    console.log("!!! PUBLIC ID: ", public_id);
    if (public_id) {
      // Update url if it's a new event
      window.history.replaceState(null, null, `/data-set/edit`);
    }
    setSavingDataSet(false);
  }

  if (!selectedDataSet && data_set_id) {
    return <Loading>Loading Data Set...</Loading>;
  }

  return (
    <div style={{ display: "flex", flexDirection: "row", backgroundColor: "var(--main-bg)", height: "100%" }}>
      <div style={{ width: "250px" }}>
        <EditDataSetSidebar
          defaultSelectedTab={selectedTab}
          onNavItemClicked={(navItem) => {
            console.log("!!! NAV ITEM CLICKED: ", navItem);
            setSelectedTab(navItem);
          }}
        />
      </div>
      <div
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          width: `calc(100% - 250px)`,
          minHeight: "calc(100vh - 40px)",
          position: "relative",
          backgroundColor: "var(--content-item-bg)",
          padding: "20px",
          borderRadius: "8px",
          color: "var(--main-font-color)",
          zIndex: 1,
          /*height: "2000px",*/
        }}
      >
        <PageHeader style={{ position: "sticky", top: "0px", backgroundColor: "var(--content-item-bg)", zIndex: 2, display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
          <div>
            <BackLink onClick={() => {
              if (activeUser?.user_type.match(/client/)) {
                navigate(`/client/data/#data-sets`);
              } else {
                navigate(`/data/#data-sets`);
              }
            }} >
              <i className="fa fa-arrow-left" /> Back to Data Sets</BackLink>
            <PageTitle title={`${updatedDataSet?.id ? "Edit" : "New"} Data Set`} style={{ marginBottom: "0px" }} />
            {updatedDataSet?.title ?
              <PageTitle title={updatedDataSet?.title} style={{ marginBottom: "10px", fontWeight: "500", fontSize: "20px" }} />
              : null}
          </div>
          <div style={{ marginLeft: "auto", display: "flex", flexDirection: "row", gap: "10px" }}>
            <CancelButton onClick={() => {
              setUpdatedDataSet(selectedDataSet);
            }}>Cancel</CancelButton>
            <Button disabled={!canSaveDataSet() || savingDataSet} onClick={saveDataSet} style={{ marginLeft: "auto" }}>{savingDataSet ? "Saving Changes" : "Save Changes"}</Button>
          </div>
        </PageHeader>
        <div style={{ backgroundColor: "var(--content-item-bg)", marginTop: "20px", marginBottom: "40px", height: "calc(100% - 80px)" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "20px", height: "100%" }}>
            <div style={{ width: "100%", height: "100%" }}>
              <CoreDetails
                style={{ display: selectedTab === "details" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />
              <DataItems style={{ display: selectedTab === "data-items" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />

              <IngestWorkflow style={{ display: selectedTab === "ingest-workflow" ? "flex" : "none" }}
                onSelectTab={(tab) => {
                  window.history.replaceState(null, null, `#${tab}`);
                  setSelectedTab(tab);
                }} />

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditDataSet;
